// extracted by mini-css-extract-plugin
module.exports = {"screen":"ScreenBlock_screen__HvZnG","spin":"ScreenBlock_spin__9UuIT","loader":"ScreenBlock_loader__U6gji"};